import { findOneWhere } from './my_simple_functions.js';

class Table {
    constructor(){
        this.count = 0;
        this.rows = [];
    }
    generate_pk() { return ++this.count }
}

const tmp_enterpreneur = new Table;
const tmp_partnership = new Table;
const tmp_partnership_member = new Table;
const tmp_business = new Table;
const tmp_branch = new Table;
const tmp_dish = new Table;
const tmp_branch_dish = new Table;
const tmp_location = new Table;
const tmp_key_search_word = new Table;
const tmp_places = new Table;

tmp_enterpreneur.rows = [
    {id: tmp_enterpreneur.generate_pk(), firstname: "Joel", lastname: "Basdeu", email: "Joel@gmail.com", cellno: null, username: "Joel@gmail.com"},
    {id: tmp_enterpreneur.generate_pk(), firstname: "Bra", lastname: "Khosi", email: "Khosi@gmail.com", cellno: null, username: "Khosi@gmail.com"},
    {id: tmp_enterpreneur.generate_pk(), firstname: "Mdala", lastname: "Peu", email: "MdalaPeu@gmail.com", cellno: null, username: "MdalaPeu@gmail.com"},
    {id: tmp_enterpreneur.generate_pk(), firstname: "The", lastname: "Bigger", email: null, cellno: "075864586", username: "075864586"},
    {id: tmp_enterpreneur.generate_pk(), firstname: "Mma", lastname: "Mochakane", email: "Mochakane@gmail.com", cellno: "012456852", username: "Mochakane@gmail.com"}
];

tmp_partnership.rows = [
    {id: tmp_partnership.generate_pk(), partnership_code: "JAMBO", creater_id: 1, partnership_type: "Solo"},
    {id: tmp_partnership.generate_pk(), partnership_code: "BRICS", creater_id: 2, partnership_type: "Partnership"},
    {id: tmp_partnership.generate_pk(), partnership_code: "NATO", creater_id: 5, partnership_type: "Partnership"},
];

tmp_partnership_member.rows = [
    {enterpreneur_id: 1, partnership_id: 1},
    {enterpreneur_id: 2, partnership_id: 2},
    {enterpreneur_id: 4, partnership_id: 2},
    {enterpreneur_id: 5, partnership_id: 3},
    {enterpreneur_id: 3, partnership_id: 3},
];

tmp_business.rows = [
    {id: tmp_business.generate_pk(), name: "Nkuku Insiders", alias: "Ko Joe Man", slogan: "Eja mpa tsi!!", food_type: "Cooked Food", partnership_id: 1},
    {id: tmp_business.generate_pk(), name: "Fish and Chips", alias: "Dichipseng", slogan: "Monate nice", food_type: "Fast Food", partnership_id: 1},
    {id: tmp_business.generate_pk(), name: "Spahlo Palace", alias: "Dibengung", slogan: null, food_type: "Fast Food", partnership_id: 2},
    {id: tmp_business.generate_pk(), name: "Dek Eet", alias: "Ko Modala Peu", slogan: "Eja o freife mala", food_type: "Cooked Food", partnership_id: 3}
];

tmp_branch.rows = [
    {id: tmp_branch.generate_pk(), branch_code: "MALA1", location_id: 1, business_id:1},
    {id: tmp_branch.generate_pk(), branch_code: "FISH_CHP1", location_id: 2, business_id:2},
    {id: tmp_branch.generate_pk(), branch_code: "FISH_CHP2", location_id: 3, business_id:2},
    {id: tmp_branch.generate_pk(), branch_code: "PALACE1", location_id: 4, business_id:3},
    {id: tmp_branch.generate_pk(), branch_code: "DEK_EET1", location_id: 5, business_id:4},
    {id: tmp_branch.generate_pk(), branch_code: "DEK_EET2", location_id: 6, business_id:4}
];

tmp_dish.rows = [
    {id: tmp_dish.generate_pk(), business_id: 1, item_name: "Mautwana & Pap", ingredients: ['Spice', 'Salt', 'Pop', 'Checken Feet'], tags: null, price: 10, picture: null},
    {id: tmp_dish.generate_pk(), business_id: 1, item_name: "Malana & Pap", ingredients: null, tags: null, price: 12, picture: null},
    {id: tmp_dish.generate_pk(), business_id: 1, item_name: "Melalana & Pap", ingredients: null, tags: null, price: 14, picture: null},
    {id: tmp_dish.generate_pk(), business_id: 2, item_name: "Fish & Chips Small", ingredients: null, tags: null, price: 18, picture: null},
    {id: tmp_dish.generate_pk(), business_id: 2, item_name: "Fish & Chipa Medium", ingredients: null, tags: null, price: 25, picture: null},
    {id: tmp_dish.generate_pk(), business_id: 2, item_name: "Fish & Chips Large", ingredients: null, tags: null, price: 30, picture: null},
    {id: tmp_dish.generate_pk(), business_id: 2, item_name: "4 Wings & Chips Small", ingredients: null, tags: null, price: 45, picture: null},
    {id: tmp_dish.generate_pk(), business_id: 2, item_name: "8 Wing & Chips Large", ingredients: null, tags: null, price: 60, picture: null},
    {id: tmp_dish.generate_pk(), business_id: 2, item_name: "2 Russian & 2 Fried Eggs Chips", ingredients: null, tags: null, price: 35, picture: null},
    {id: tmp_dish.generate_pk(), business_id: 2, item_name: "Small Chips", ingredients: null, tags: null, price: 15, picture: null},
    {id: tmp_dish.generate_pk(), business_id: 2, item_name: "Medium Chips", ingredients: null, tags: null, price: 20, picture: null},
    {id: tmp_dish.generate_pk(), business_id: 2, item_name: "Large Chips", ingredients: null, tags: null, price: 25, picture: null},
    {id: tmp_dish.generate_pk(), business_id: 3, item_name: "Nox Man", ingredients: null, tags: null, price: 10, picture: null},
    {id: tmp_dish.generate_pk(), business_id: 3, item_name: "Chees Girl", ingredients: null, tags: null, price: 15, picture: null},
    {id: tmp_dish.generate_pk(), business_id: 3, item_name: "Sidla Bantwana", ingredients: null, tags: null, price: 20, picture: null},
    {id: tmp_dish.generate_pk(), business_id: 4, item_name: "Mokekerepa & Pap", ingredients: null, tags: null, price: 25, picture: null},
    {id: tmp_dish.generate_pk(), business_id: 4, item_name: "Nama Hlogo & Pap", ingredients: null, tags: null, price: 30, picture: null},
    {id: tmp_dish.generate_pk(), business_id: 4, item_name: "Mogodu & Pap", ingredients: null, tags: null, price: 25, picture: null},
    {id: tmp_dish.generate_pk(), business_id: 4, item_name: "Half Skop Nku & Pap", ingredients: null, tags: null, price: 40, picture: null},
    {id: tmp_dish.generate_pk(), business_id: 4, item_name: "Half Skop Kolobe & Pap", ingredients: null, tags: null, price: 55, picture: null},
];

tmp_branch_dish.rows = [
    {dish_id: 1, branch_id: 1, branch_price: 12},
    {dish_id: 2, branch_id: 1, branch_price: 14},
    {dish_id: 3, branch_id: 1, branch_price: null},
    {dish_id: 4, branch_id: 2, branch_price: null},
    {dish_id: 5, branch_id: 2, branch_price: 28},
    {dish_id: 6, branch_id: 2, branch_price: null},
    {dish_id: 7, branch_id: 2, branch_price: null},
    {dish_id: 8, branch_id: 2, branch_price: null},
    {dish_id: 9, branch_id: 2, branch_price: null},
    {dish_id: 10, branch_id: 2, branch_price: null},
    {dish_id: 11, branch_id: 2, branch_price: null},
    {dish_id: 12, branch_id: 2, branch_price: null},
    {dish_id: 4, branch_id: 3, branch_price: null},
    {dish_id: 5, branch_id: 3, branch_price: null},
    {dish_id: 6, branch_id: 3, branch_price: null},
    {dish_id: 7, branch_id: 3, branch_price: null},
    {dish_id: 8, branch_id: 3, branch_price: null},
    {dish_id: 9, branch_id: 3, branch_price: null},
    {dish_id: 10, branch_id: 3, branch_price: null},
    {dish_id: 11, branch_id: 3, branch_price: null},
    {dish_id: 12, branch_id: 3, branch_price: null},
    {dish_id: 13, branch_id: 4, branch_price: null},
    {dish_id: 14, branch_id: 4, branch_price: null},
    {dish_id: 15, branch_id: 4, branch_price: null},
    {dish_id: 16, branch_id: 5, branch_price: null},
    {dish_id: 17, branch_id: 5, branch_price: null},
    {dish_id: 18, branch_id: 5, branch_price: null},
    {dish_id: 19, branch_id: 5, branch_price: null},
    {dish_id: 20, branch_id: 5, branch_price: null},
    {dish_id: 17, branch_id: 6, branch_price: 35},
    {dish_id: 18, branch_id: 6, branch_price: null},
    {dish_id: 20, branch_id: 6, branch_price: null},
];


tmp_places.rows = [
    {id: tmp_places.generate_pk(), name: "Limpopo", type: "province",  major_two: null, major_one: null}, // id = 1
    {id: tmp_places.generate_pk(), name: "North West", type: "province",  major_two: null, major_one: null}, // id = 2
    {id: tmp_places.generate_pk(), name: "Mpumalanga", type: "province",  major_two: null, major_one: null}, // id = 3
    {id: tmp_places.generate_pk(), name: "Gauteng", type: "province",  major_two: null, major_one: null}, // id = 4
    {id: tmp_places.generate_pk(), name: "Kwa-Zulu Natal", type: "province",  major_two: null, major_one: null}, // id = 5
    {id: tmp_places.generate_pk(), name: "Free-State", type: "province",  major_two: null, major_one: null}, // id = 6
    {id: tmp_places.generate_pk(), name: "Nothern Cape", type: "province",  major_two: null, major_one: null}, // id = 7
    {id: tmp_places.generate_pk(), name: "Eastern Cape", type: "province",  major_two: null, major_one: null}, // id = 8
    {id: tmp_places.generate_pk(), name: "Western Cape", type: "province",  major_two: null, major_one: null}, // id = 9
    {id: tmp_places.generate_pk(), name: "Pretoria", type: "city", major_two: 4, major_one: null},  // id = 10
    {id: tmp_places.generate_pk(), name: "Soshanguve", type: "township",  major_two: 10, major_one: 4}, // id = 11
    {id: tmp_places.generate_pk(), name: "Mabopane", type: "township", major_two: 10, major_one: 2}, // id = 12
    {id: tmp_places.generate_pk(), name: "Block L", type: "block",  major_two: 11, major_one: 10}, // id = 13
    {id: tmp_places.generate_pk(), name: "Block C", type: "block",  major_two: 12, major_one: 10}, // id = 14
    {id: tmp_places.generate_pk(), name: "Block H", type: "block",  major_two: 11, major_one: 10}, // id = 15
    {id: tmp_places.generate_pk(), name: "Block K", type: "block",  major_two: 11, major_one: 10}, // id = 16
    {id: tmp_places.generate_pk(), name: "Block AA", type: "block",  major_two: 11, major_one: 10}, // id = 17
    {id: tmp_places.generate_pk(), name: "Block BB", type: "block",  major_two: 11, major_one: 10}, // id = 18
    {id: tmp_places.generate_pk(), name: "Block JJ", type: "block",  major_two: 11, major_one: 10}, // id = 19
    {id: tmp_places.generate_pk(), name: "Block NN", type: "block",  major_two: 11, major_one: 10}, // id = 20
    {id: tmp_places.generate_pk(), name: "Block F", type: "block",  major_two: 11, major_one: 10}, // id = 21
    {id: tmp_places.generate_pk(), name: "Block FF", type: "block",  major_two: 11, major_one: 10}, // id = 22
    {id: tmp_places.generate_pk(), name: "Block G", type: "block",  major_two: 11, major_one: 10}, // id = 23
    {id: tmp_places.generate_pk(), name: "Block GG", type: "block",  major_two: 11, major_one: 10}, // id = 24
    {id: tmp_places.generate_pk(), name: "Block W", type: "block",  major_two: 11, major_one: 10}, // id = 25
];


tmp_location.rows = [
    {id: tmp_location.generate_pk(), geo_location: "[-12122212, 256454895]", wellknown_name: "Ga Mmine", block_id: 16, township_id: 11, city_id: 10, province_id: 4},
    {id: tmp_location.generate_pk(), geo_location: "[-12122212, 256454895]", wellknown_name: "Ausi Celia", block_id: 13, township_id: 11, city_id: 10, province_id: 4},
    {id: tmp_location.generate_pk(), geo_location: "[-12122212, 256454895]", wellknown_name: "Ga Mmine", block_id: 14, township_id: 12, city_id: 10, province_id: 2},
    {id: tmp_location.generate_pk(), geo_location: "[-12122212, 256454895]", wellknown_name: "" , block_id: 13, township_id: 11, city_id: 10, province_id: 4},
    {id: tmp_location.generate_pk(), geo_location: "[-12122212, 256454895]", wellknown_name: "", block_id: 15, township_id: 11, city_id: 10, province_id: 4},
    {id: tmp_location.generate_pk(), geo_location: "[-12122212, 256454895]", wellknown_name: "Bra Mish", block_id: 13, township_id: 11, city_id: 10, province_id: 4}
];



tmp_key_search_word.rows = [
    {index: tmp_key_search_word.generate_pk(), place_id: null, search_phrase: "Ga Mmine", type: "wellknown_name"},
    {index: tmp_key_search_word.generate_pk(), place_id: null, search_phrase: "Ausi Celia", type: "wellknown_name"},
    {index: tmp_key_search_word.generate_pk(), place_id: null, search_phrase: "Bra Mish", type: "wellknown_name"},
];

tmp_places.rows.forEach(place => {
    const major_two = place.major_two ? findOneWhere(tmp_places.rows, {id: place.major_two}) : null;
    const major_one = place.major_one ? findOneWhere(tmp_places.rows, {id: place.major_one}) : null;

    const search_phrase = place.name + (major_two ? ', ' + major_two.name : '') + (major_one ? ', ' + major_one.name : '');
    const search_word = {index: tmp_key_search_word.generate_pk(), place_id: place.id, search_phrase, type: place.type};
    tmp_key_search_word.rows.push(search_word);
});

export const enterpreneur = Object.assign({}, tmp_enterpreneur);
export const partnership = Object.assign({}, tmp_partnership);
export const partnership_member = Object.assign({}, tmp_partnership_member);
export const business = Object.assign({}, tmp_business);
export const branch = Object.assign({}, tmp_branch);
export const dish = Object.assign({}, tmp_dish);
export const branch_dish = Object.assign({}, tmp_branch_dish);
export const location = Object.assign({}, tmp_location);
export const place = Object.assign({}, tmp_places);
export const search_word = Object.assign({}, tmp_key_search_word);
